const icons = {
  Linkedin: 'linkedin',
  Twitter: 'x-twitter',
  Youtube: 'youtube-play'
}

export type IconType = 'Youtube' | 'Linkedin' | 'Twitter'

export const getIconClass = (name: IconType) => icons[name]
